import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { ReportTypeEntity } from './report-type.model';

/* eslint-disable @typescript-eslint/no-shadow */
export enum ReportTypeActionTypes {
  LoadReportTypes = '[ReportType] Load ReportTypes',
  AddReportType = '[ReportType] Add ReportType',
  UpsertReportType = '[ReportType] Upsert ReportType',
  AddReportTypes = '[ReportType] Add ReportTypes',
  UpsertReportTypes = '[ReportType] Upsert ReportTypes',
  UpdateReportType = '[ReportType] Update ReportType',
  UpdateReportTypes = '[ReportType] Update ReportTypes',
  DeleteReportType = '[ReportType] Delete ReportType',
  DeleteReportTypes = '[ReportType] Delete ReportTypes',
  ClearReportTypes = '[ReportType] Clear ReportTypes',
}
/* eslint-enable @typescript-eslint/no-shadow */

export class LoadReportTypes implements Action {
  public readonly type = ReportTypeActionTypes.LoadReportTypes;

  constructor(public payload: { reportTypes: ReportTypeEntity[] }) {}
}

export class AddReportType implements Action {
  public readonly type = ReportTypeActionTypes.AddReportType;

  constructor(public payload: { reportType: ReportTypeEntity }) {}
}

export class UpsertReportType implements Action {
  public readonly type = ReportTypeActionTypes.UpsertReportType;

  constructor(public payload: { reportType: ReportTypeEntity }) {}
}

export class AddReportTypes implements Action {
  public readonly type = ReportTypeActionTypes.AddReportTypes;

  constructor(public payload: { reportTypes: ReportTypeEntity[] }) {}
}

export class UpsertReportTypes implements Action {
  public readonly type = ReportTypeActionTypes.UpsertReportTypes;

  constructor(public payload: { reportTypes: ReportTypeEntity[] }) {}
}

export class UpdateReportType implements Action {
  public readonly type = ReportTypeActionTypes.UpdateReportType;

  constructor(public payload: { reportType: Update<ReportTypeEntity> }) {}
}

export class UpdateReportTypes implements Action {
  public readonly type = ReportTypeActionTypes.UpdateReportTypes;

  constructor(public payload: { reportTypes: Update<ReportTypeEntity>[] }) {}
}

export class DeleteReportType implements Action {
  public readonly type = ReportTypeActionTypes.DeleteReportType;

  constructor(public payload: { id: string }) {}
}

export class DeleteReportTypes implements Action {
  public readonly type = ReportTypeActionTypes.DeleteReportTypes;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearReportTypes implements Action {
  public readonly type = ReportTypeActionTypes.ClearReportTypes;
}

export type ReportTypeActions =
  | LoadReportTypes
  | AddReportType
  | UpsertReportType
  | AddReportTypes
  | UpsertReportTypes
  | UpdateReportType
  | UpdateReportTypes
  | DeleteReportType
  | DeleteReportTypes
  | ClearReportTypes;
